<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    title-text="Выберите публикацию"
    cancel-btn="Отменить"
    success-btn="Выбрать"
    @submit="onSubmit"
    @closed="$emit('closed')"
  >
    <v-row dense>
      <v-col cols="12">
        <BAutocompleteCommon
          v-model="model"
          $type="publication"
          label="Публикация"
          placeholder="Начните вводить..."
        />
      </v-col>

      <v-col v-if="model" cols="12">
        <b>Ссылка:</b> <span>{{ link }}</span>
      </v-col>
    </v-row>
  </BModalConfirm>
</template>


<script>
import { LK_PUBLICATIONS_ROUTES } from '@/views/LKPublications/utils'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


export default {
  name: 'NotificationBannersPublicationSelect',
  components: {
    BModalConfirm,
    BAutocompleteCommon,
  },
  inheritAttrs: false,
  props: {
  },
  data: () => ({
    model: null,
  }),
  computed: {
    link() {
      if (!this.model) return null

      const location = {
        name: LK_PUBLICATIONS_ROUTES.VIEW_ONCE,
        params: {
          slug: this.model.slug,
          // topic_slug: null,
        },
      }

      const { href } = this.$router.resolve(location)

      return href === '/' ? null : href
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(flag) {
      return this.$refs.modal.close(flag)
    },
    onSubmit() {
      const params = this.link ? { link: this.link } : null
      this.close(params)
    },
  },
}
</script>
